import { useContext } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./ProductionHeader1.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";

 
import { trackPageVisit } from "../competency/PageTracker";


 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }



function ProductionHeader1() {

        useEffect(() => {
  
    trackPageVisit("ProductionHeader1");
  
  }, []);

  const {  wellSignals, valves, toggleValve, setTransmitters  } = useContext(WellContext);

      const [valveData, setValveData] = useState(() => {
    const saved = localStorage.getItem("ProductionHeader1_valveData");
    return saved
      ? JSON.parse(saved)
      : {
            FCV_10501: { mode: "Manual", opening: 0, sp: "", pv: "" },
            };
        });



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("ProductionHeader1_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
    setValveData(prev => ({
      ...prev,
      [tag]: {
        ...prev[tag],
        [field]: field === "opening" ? Number(value) || 0 : value
      }
    }));
  };

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };







              /* 🔥 TRANSMITTER OUTPUTS */


const isXV10103Open = !valves.XV_10103;
const isXV10203Open = !valves.XV_10203;
const isXV10501Open = !valves.XV_10501;
const isXV10502Open = !valves.XV_10502;


const FIC_105011 = isXV10501Open && isXV10103Open
  ? (wellSignals?.NK1?.fic2 || 0)
  : 0;

const FIC_105012 = isXV10502Open && isXV10203Open
  ? (wellSignals?.NK2?.fic2 || 0)
  : 0;

  /* ================= TOTAL FLOW ================= */
const FIC_10501 =  FIC_105011 +  FIC_105012


  
const PT_105011 = isXV10501Open && isXV10103Open
  ? (wellSignals?.NK1?.pt2 || 0)
  : 0;

const PT_105012 = isXV10502Open && isXV10203Open
  ? (wellSignals?.NK2?.pt2 || 0)
  : 0;

  /* ================= TOTAL PRESSURE ================= */
const PT_10501 =
  PT_105011 != null && !isNaN(PT_105011)
    ? PT_105011
    : PT_105012;



const TT_105011 = isXV10501Open && isXV10103Open
  ? (wellSignals?.NK1?.tt || 0)
  : 0;

const TT_105012 = isXV10502Open && isXV10203Open
  ? (wellSignals?.NK2?.tt || 0)
  : 0;

  /* ================= TOTAL PRESSURE ================= */
const activeTemperature = [
  TT_105011,
  TT_105012,
].filter(p => p > 0); // ignore closed valves (0 values)

const TT_10501 =
  activeTemperature.length > 0
    ? activeTemperature.reduce((a, b) => a + b, 0) / activeTemperature.length
    : 0;





const isXV10504Open = !valves.XV_10504;

const MPFT_105011 =
  isXV10501Open && isXV10103Open && isXV10504Open
    ? (
        (wellSignals?.NK1?.oil || 0) 
      )
    : 0;

const MPFT_105012 =
  isXV10502Open && isXV10203Open && isXV10504Open
    ? (
        (wellSignals?.NK2?.oil || 0)
      )
    : 0;
  
  const MPFT_10501 = MPFT_105011 +  MPFT_105012



  const MPFT_105021 =
  isXV10501Open && isXV10103Open && isXV10504Open
    ? (
        (wellSignals?.NK1?.gas || 0) 
      )
    : 0;

const MPFT_105022 =
  isXV10502Open && isXV10203Open && isXV10504Open
    ? (
        (wellSignals?.NK2?.gas || 0)
      )
    : 0;



  const MPFT_10502 = MPFT_105021 +  MPFT_105022





  const MPFT_105031 =
  isXV10501Open && isXV10103Open && isXV10504Open
    ? (
        (wellSignals?.NK1?.water || 0) 
      )
    : 0;

const MPFT_105032 =
  isXV10502Open && isXV10203Open && isXV10504Open
    ? (
        (wellSignals?.NK2?.water || 0)
      )
    : 0;


  const MPFT_10503 = MPFT_105031 +  MPFT_105032





const [fic10503, setFic10503] = useState(0);

const isXV10503Open = !valves.XV_10503;

useEffect(() => {
  const target = isXV10503Open ? 45.432 : 0;

  const interval = setInterval(() => {
    setFic10503(prev => {
      const diff = target - prev;

      // smooth approach
      let next = prev + diff * 0.1;

      // snap when very close
      if (Math.abs(diff) < 0.01) {
        next = target;
      }

      return next;
    });
  }, 100);

  return () => clearInterval(interval);
}, [isXV10503Open]);


const FIC_10502 = 20.342 * (valveData.FCV_10501.opening)/100;





useEffect(() => {
  if (!setTransmitters) return;

  setTransmitters(prev => ({
    ...prev,
    MPFT_10501,
    MPFT_10502,
    MPFT_10503,
    PT_10501,   // 🔥 ADD THIS
    TT_10501,    // optional but recommended
    FIC_10501
  }));
}, [
  MPFT_10501,
  MPFT_10502,
  MPFT_10503,
  PT_10501,
  TT_10501,
  setTransmitters,
  FIC_10501
]);



  return (
    <div className="ProductionHeader1-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "243px",
        color: "white",
        background: "rgb(29, 4, 253)",
        padding: "2.2px 289px"
      }}>
        PRODUCTION HEADER 1
      </h2>


    {/* =================SHUTDOWN VALVES ================= */}

      {/* XV-10601 */}
      <Valve
        className="XV-10501"
        tag="XV_10501"
        x={149}
        y={78}
        isClosed={valves.XV_10501}
        toggle={toggleValve}
      />

      {/* XV-10502 */}
      <Valve
        className="XV-10502"
        tag="XV_10502"
        x={150}
        y={166}
        isClosed={valves.XV_10502}
        toggle={toggleValve}
      />

        {/* XV-10503 */}
      <Valve
        className="XV-10503"
        tag="XV_10503"
        x={778}
        y={433}
        isClosed={valves.XV_10503}
        toggle={toggleValve}
      />

        {/* XV-10504 */}
      <Valve
        className="XV-10504"
        tag="XV_10504"
        x={1008}
        y={185}
        isClosed={valves.XV_10504}
        toggle={toggleValve}
      />


      <Transmitter4
          value={FIC_105011} x={120} y={112} c="transparent"
        />

        <Transmitter4
          value={FIC_105012} x={120} y={162} c="transparent"
        />


    <Transmitter
      value={FIC_10501}
      x={592}
      y={328}
      unit="BOE/M"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF OIL AND GAS FLUID FROM NK-1 AND NK-2 WELLHEADS"
      tag="FIC-10501"
     />

        <Transmitter4
          value={PT_105011} x={240} y={112} c="transparent"
        />

        <Transmitter4
          value={PT_105012} x={240} y={162} c="transparent"
        />


    <Transmitter
      value={PT_10501}
      x={752}
      y={328}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF OIL AND GAS FLUID FROM NK-1 AND NK-3 WELLHEADS"
      tag="PT_10501"
     />

        <Transmitter4
          value={TT_105011} x={240} y={112} c="transparent"
        />

    <Transmitter
      value={TT_10501}
      x={850}
      y={328}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF OIL AND GAS FLUID FROM NK-1 AND NK-2 WELLHEADS"
      tag="TT-10501"
     />

        <Transmitter4
          value={TT_105012} x={240} y={162} c="transparent"
        />


        <Transmitter4
          value={MPFT_105011} x={900} y={112} c="transparent"
        />

        <Transmitter4
          value={MPFT_105012} x={900} y={162} c="transparent"
        />

    <Transmitter
      value={MPFT_10501}
      x={1072}
      y={117}
      unit="BPM"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF CRUDE FROM NK-1 AND NK-2 WELLHEADS TO PIG LAUNCHER"
      tag="MPFT-10501"
     />

    <Transmitter
      value={MPFT_10502}
      x={1072}
      y={131}
      unit="SCF/S"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF GAS FROM NK-1 AND NK-2 WELLHEADS TO PIG LAUNCHER"
      tag="MPFT-10502"
     />

    <Transmitter
      value={MPFT_10503}
      x={1072}
      y={144}
      unit="SCF/S"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF SEDIMENT AND WATER FROM NK-1 AND NK-2 WELLHEADS TO PIG LAUNCHER"
      tag="MPFT-10503"
     />

        <Transmitter4
          value={MPFT_105021} x={910} y={112} c="transparent"
        />

        <Transmitter4
          value={MPFT_105022} x={910} y={162} c="transparent"
        />

           <Transmitter4
          value={MPFT_105031} x={920} y={112} c="transparent"
        />

        <Transmitter4
          value={MPFT_105032} x={920} y={162} c="transparent"
        />


    <Transmitter
      value={fic10503}
      x={929}
      y={429}
      unit="BOE/M"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF OIL AND GAS FLUID TO CLOSE DRAIN FROM PRODUCTION HEADER-1"
      tag="FIC-10503"
     />

    <Transmitter
      value={FIC_10502}
      x={800}
      y={104}
      unit="LPM"
      max={170}
      HH={155}
      H={110}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF DEMULSIFIER CHEMICAL USED FOR INJECTION INTO PRODUCTION HEADER-1"
      tag="FIC-10502"
     />
    



      

      {/* ================= CONTROL VALVES SVG ================= */}

        {/* FCV-10501 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10501"
          style={{ position: "absolute", left: 723, top: 113 }}  onClick={() => openPanel("FCV_10501")}>
          
          <defs>
            <linearGradient id="metal_10501">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10501)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10501)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        
      {/* ================= FACEPLATES ================= */}
      {openPanels.map((tag, index) => (
        <ControlValveControlPanel
          key={tag}
          tag={tag}
          data={valveData[tag]}
          update={updateValveData}   // ✅ FIXED
          close={() => closePanel(tag)}
          defaultPosition={{
            x: 300 + index * 40,
            y: 150 + index * 40
          }}
        />
      ))}





      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={valveData.FCV_10501.opening}
        x={745}
        y={165}
      />

      

    </div>
  );
}

export default ProductionHeader1;
